// Internal feature flag utility
const feature = (enabled = false, required = false) => ({ enabled, required });

// Common presets
const ENABLED = feature(true, false);

const DISABLED = feature(false, false);

// Default feature configuration
const defaultFeatures = {
  video_quality: DISABLED,
  audio_quality: DISABLED,
  encryption: DISABLED,
  video_preview: DISABLED,
  ai_thumbnail: DISABLED,
  embedded_podcast: DISABLED,
  transcript: DISABLED,
  audio_waveform: DISABLED,
  language: ENABLED,
};

// Utility to override defaults
const withOverrides = (
  overrides: Partial<typeof defaultFeatures>
): typeof defaultFeatures => ({
  ...defaultFeatures,
  ...overrides,
});

// Media type-specific feature maps
const mediaFeatureMap = {
  video: withOverrides({
    video_quality: ENABLED,
    audio_quality: DISABLED,
    encryption: ENABLED,
    video_preview: ENABLED,
    ai_thumbnail: ENABLED,
    embedded_podcast: ENABLED,
    transcript: ENABLED,
  }),
  audio: withOverrides({
    audio_quality: ENABLED,
    encryption: ENABLED,
    ai_thumbnail: ENABLED,
    transcript: ENABLED,
    audio_waveform: ENABLED,
  }),
  drive: withOverrides({
    video_preview: ENABLED,
    transcript: ENABLED,
  }),
  campaign: withOverrides({
    video_quality: ENABLED,
    audio_quality: ENABLED,
    ai_thumbnail: ENABLED,
    transcript: ENABLED,
  }),
  shorts: withOverrides({
    video_quality: ENABLED,
    ai_thumbnail: ENABLED,
    transcript: ENABLED,
  }),
  slates: withOverrides({}),
} as const;

export type MediaFeatureMapKey = keyof typeof mediaFeatureMap;
export type MediaFeatures = typeof defaultFeatures;

// Public React hook to access media features
export const CustomUploadConfig = (type: MediaFeatureMapKey): MediaFeatures => {
  return mediaFeatureMap[type] ?? defaultFeatures;
};
